export default __webpack_public_path__ + "static/media/default.cc82533c.png";